import { useState } from 'react';

interface UseDownGradeOfferProps {
  selectedOption: string;
  handleDowngrade: () => void;
}

export const useDownGradeOffer = ({
  selectedOption,
  handleDowngrade
}: UseDownGradeOfferProps) => {
  const [facingBugsFeatureFromOfferModal, setFacingBugsFeatureFromOfferModal] = useState<string>('');
  const [isFacingBugsFieldErrorFromOfferModal, setIsFacingBugsFieldErrorFromOfferModal] = useState<boolean | null>(null);
  const [isMinCharFacingBugsErrorFromOfferModal, setIsMinCharFacingBugsErrorFromOfferModal] = useState<boolean | null>(null);
  const [isOfferProcess, setIsOfferApplied] = useState(false);

  const isFacingBugs = selectedOption === 'Facing bugs';

  const handleContinue = () => {
    if (isFacingBugs && facingBugsFeatureFromOfferModal?.length === 0) {
      setIsFacingBugsFieldErrorFromOfferModal(true);
      return;
    }
    if (isFacingBugs && facingBugsFeatureFromOfferModal?.length < 30) {
      setIsMinCharFacingBugsErrorFromOfferModal(true);
      return;
    }
    setIsFacingBugsFieldErrorFromOfferModal(false);
    setIsMinCharFacingBugsErrorFromOfferModal(false);
    handleDowngrade();
  };

  return {
    facingBugsFeatureFromOfferModal,
    setFacingBugsFeatureFromOfferModal,
    isFacingBugsFieldErrorFromOfferModal,
    setIsFacingBugsFieldErrorFromOfferModal,
    isMinCharFacingBugsErrorFromOfferModal,
    setIsMinCharFacingBugsErrorFromOfferModal,
    isOfferProcess,
    setIsOfferApplied,
    handleContinue
  };
};
